module.exports = __webpack_public_path__ + "assets/img/35_1123.40e2fe6e.jpg";